<template>
  <div class="netpa-page-panel row">
    <div class="col-12">
      <div
        class="alert w-100 netpa-page-panel__alert"
        :class="ClassCustom"
        dir="rtl"
      >
        <div class="netpa-page-panel__content">
          <b class="text-warning netpa-page-panel__title">{{ Title }}،</b
          ><span v-if="Des != ''" class="text-light netpa-page-panel__desc">
            {{ Des }}</span
          >
        </div>
        <button
          v-if="IsBtnBack == true"
          type="button"
          class="netpa-page-panel__back-btn"
          title="بازگشت به صفحه قبلی"
          @click="Back"
        >
          <i class="fas fa-arrow-left text-warning" aria-hidden="true"></i>
        </button>
        <button
          v-if="IsBtnClose == true"
          type="button"
          class="netpa-page-panel__back-btn"
          title="بستن"
          data-dismiss="modal"
        >
          <i class="fas fa-times text-warning" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  props: ["Title", "Des", "ClassCustom", "IsBtnBack", "IsBtnClose"],
  methods: {
    Back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.bg-dark-Custom {
  background: #2a3f54 !important;
}

.netpa-page-panel {
  margin-left: 0;
  margin-right: 0;
  max-width: 100%;
}

.netpa-page-panel > .col-12 {
  padding-left: 0;
  padding-right: 0;
  max-width: 100%;
  min-width: 0;
}

.netpa-page-panel__alert {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  flex-wrap: nowrap;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 0;
}

.netpa-page-panel__content {
  flex: 1 1 auto;
  min-width: 0;
  text-align: right;
  line-height: 1.5;
}

.netpa-page-panel__title {
  display: inline;
  font-size: 15px !important;
}

.netpa-page-panel__desc {
  display: inline;
  font-size: inherit;
}

.netpa-page-panel__back-btn {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  padding: 0;
  margin: 0;
  border: none;
  border-radius: 8px;
  background: transparent;
  cursor: pointer;
  line-height: 1;
}

.netpa-page-panel__back-btn i {
  font-size: 18px;
  pointer-events: none;
}

.netpa-page-panel__back-btn:hover {
  background: rgba(255, 193, 7, 0.12);
}

.netpa-page-panel__back-btn:focus {
  outline: none;
}

.netpa-page-panel__back-btn:focus-visible {
  outline: 2px solid rgba(255, 193, 7, 0.55);
  outline-offset: 2px;
}
</style>
